import React from 'react';
import { connect } from 'react-redux'
import { Table, Row, Col, Button, Dropdown, Pagination, Tag } from 'antd';
import { SettingOutlined, DownCircleOutlined, CloseCircleOutlined, EditOutlined, SendOutlined, FileSyncOutlined, IssuesCloseOutlined, CheckCircleOutlined, FileDoneOutlined, RollbackOutlined } from '@ant-design/icons';
import { getParamTable, _tableLogActivity } from '../../../../lib/Helper';

const statusLabels = {
  "Draft": "yellow",
  "Diajukan": "",
  "Disetujui": "blue",
  "Ditolak": "red",
  "Dibatalkan": "red",
  "Dikembalikan": "",
  "Selesai": "green",
}

const statusIcons = {
  "Draft": <FileSyncOutlined />,
  "Diajukan": <SendOutlined style={{ transform: "rotate(-30deg)" }} />,
  "Disetujui": <CheckCircleOutlined />,
  "Ditolak": <CloseCircleOutlined />,
  "Dibatalkan": <IssuesCloseOutlined />,
  "Dikembalikan": <RollbackOutlined />,
  "Selesai": <FileDoneOutlined />,
}

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  sorter: false,
                  width: '2%',
                }, {
                  title: 'Tanggal Pinjam',
                  dataIndex: '',
                  sorter: false,
                  render: (a, row) => <>
                    <span style={{
                      fontSize: "100%",
                      fontStyle: "italic"
                    }}>{row.tgl_awal}</span> <br />
                    to <br />
                    <span style={{
                      fontSize: "100%",
                      fontStyle: "italic"
                    }}>{row.tgl_akhir}</span> <br />
                  </>,
                }, {
                  title: 'Peminjam',
                  dataIndex: '',
                  sorter: false,
                  render: (a, row) => (row.gelar_depan ? row.gelar_depan + " " : "") + (row.tk_nama ? row.tk_nama : "-") + (row.gelar_belakang ? " " + row.gelar_belakang : "")
                }, {
                  title: 'Kategori/Unit',
                  dataIndex: '',
                  sorter: false,
                  render: (a, row) => <>
                    {row.kategori_nama}, <br />
                    {row.unit_nama}, {row.unit_ruangan_nama ? `(${row.unit_ruangan_nama})` : "-"} <br />
                  </>,
                }, {
                  title: 'Ruangan',
                  dataIndex: 'ruangan_nama',
                  sorter: false,
                }, {
                  title: 'Lahan/Gedung',
                  dataIndex: '',
                  sorter: false,
                  render: (a, row) => <>
                    {row.lahan_nama}, <br />
                    {row.gedung_nama} <br />
                  </>,
                }, {
                  title: 'Jumlah Pinjaman',
                  dataIndex: 'jml',
                  sorter: false,
                }, {
                  title: 'Status',
                  dataIndex: 'status',
                  sorter: false,
                  render: (a, row) => <Tag style={{ width: "100%" }} color={statusLabels[row.status]} icon={statusIcons[row.status]}>{row.status}</Tag>
                }, {
                  title: 'Keterangan',
                  dataIndex: 'keterangan',
                  sorter: false,
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => ((row.status === "Diajukan" || row.status === "Dikembalikan" || row.status === "Disetujui" || row.status === "Draft") ? "-" : row.status === "Selesai" || row.status === "Dibatalkan" || row.status === "Ditolak" ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.update && row.status === "Draft" ? [{
    key: 0,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.request_approval && row.status === "Draft" ? [{
    key: 1,
    icon: <SendOutlined style={{
      transform: "rotate(-30deg)"
    }} />,
    label: "Minta Persetujuan",
    onClick: this.props.modalRequestApproval.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Diajukan" ? [{
    key: 2,
    icon: <CheckCircleOutlined />,
    label: "Setujui",
    onClick: this.props.modalApprove.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Diajukan" ? [{
    key: 3,
    icon: <CloseCircleOutlined />,
    label: "Tolak",
    onClick: this.props.modalReject.bind(this, true, row)
  }] : []), ...(action.request_approval && row.status === "Disetujui" ? [{
    key: 4,
    icon: <RollbackOutlined />,
    label: "Kembalikan Barang",
    onClick: this.props.modalReturn.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Dikembalikan" ? [{
    key: 5,
    icon: <FileDoneOutlined />,
    label: "Konfirmasi Pengembalian Barang",
    onClick: this.props.modalDone.bind(this, true, row)
  }] : []), ...(action.approval && row.status === "Disetujui" ? [{
    key: 6,
    icon: <IssuesCloseOutlined />,
    label: "Batalkan",
    onClick: this.props.modalCancel.bind(this, true, row)
  }] : []), ...(action.delete && row.status === "Draft" ? [{
    key: 7,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>),
                }, {
                  title: 'LogActivity',
                  key: 'operation',
                  width: '10%',
                  render: (a, row) => _tableLogActivity(row),
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Desktop);
